export default __webpack_public_path__ + "static/media/element_95.9f9c7888.webp";